import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  modalInner: {
    width: 330,
    maxWidth: 330,
    padding: '40px 15px',
    backgroundColor: theme.colors.dark.midnightBlue,
    borderRadius: 18,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,

    '@media(max-width:380px)': {
      maxWidth: 300,
    },

    '@media(max-width:340px)': {
      maxWidth: 280,
    },
  },
  iconWrapper: {
    position: 'absolute',
    top: -34,
    right: -8,
    zIndex: 1,
  },
}));
